import type { EditSessionState, RecentEditSessionSnapshot } from "@/types/project";

/** Inline mainspace Edit mode auto-exits after this long even without a reload or approval. */
export const EDIT_SESSION_TTL_MS = 24 * 60 * 60 * 1000;

/** A manually-closed edit session's snapshot (see `RecentEditSessionSnapshot`) stays restorable this long. */
export const RECENT_EDIT_SESSION_TTL_MS = 15 * 60 * 1000;

/** Whether `session` should still be shown as an active edit (not expired). Undefined session -> false. */
export function isEditSessionActive(session: EditSessionState | undefined, now: number = Date.now()): boolean {
  return session !== undefined && now - session.startedAt < EDIT_SESSION_TTL_MS;
}

/**
 * Whether a saved snapshot is still eligible to be restored for `currentEntityImageId` - within its
 * TTL and the entity's current image still matches what it was when the snapshot was taken.
 */
export function isRecentEditSessionSnapshotRestorable(
  snapshot: RecentEditSessionSnapshot | undefined,
  currentEntityImageId: string | null,
  now: number = Date.now()
): boolean {
  return snapshot !== undefined && now - snapshot.closedAt < RECENT_EDIT_SESSION_TTL_MS && snapshot.entityImageIdAtClose === currentEntityImageId;
}
